import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin-top: 16px;
  height: 100%;
  padding: 16px 32px;
  overflow-y: auto;
`;

export const Content = styled.div`
  font-size: 14px;
  font-weight: normal;
  line-height: 26px;
  color: var(--Text-Primary);
  font-family: PingFang SC;
`;
